import { render, staticRenderFns } from "./point.vue?vue&type=template&id=206d5564"
import script from "./point.vue?vue&type=script&lang=ts"
export * from "./point.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports